import NoContentFoundContainer from './NoContentFoundContainer';
export default NoContentFoundContainer;
